// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"4eac1a19","320":"1e76ad5e","328":"baf61660","366":"dedfd837","442":"cc0128ea","604":"7dcf10fb","775":"d555cf65"}[chunkId] + ".chunk.js";
};